import { ChartSeriesXY, ChartTooltipFormatterOptions } from '../data/chart-data-types';
import { customElement } from 'lit/decorators.js';
import { EventTemplate } from '../../../../webmodule-common/interop/webmodule-interop';
import { html, PropertyValueMap, TemplateResult } from 'lit';
import { ModalDialog } from '../../../../webmodule-common/other/ui/modal-base';
import { moneyToCompactStr, moneyToStr } from '../../../../webmodule-common/other/currency-formatter';
import { tlang } from '../../../../webmodule-common/other/language/lang';

const ApexCharts = (globalThis as any).ApexCharts;

@customElement('wm-timelinewidgetmodal')
export class TimelineWidgetModal extends ModalDialog {
  protected _title: string;
  protected seriesData: ChartSeriesXY[] = [];
  public xAxisCategories: string[] = [];

  chart: any | null = null;

  constructor(title: string, seriesData: ChartSeriesXY[], xAxisCategories: string[]) {
    super();

    this._title = title;
    this.seriesData = seriesData;
    this.xAxisCategories = xAxisCategories;
  }

  public getTitle() {
    return this._title;
  }

  protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const options = {
      chart: {
        type: 'area',
        events: {
          updated: function (_chartContext, _config) {
            self.addFilterTextToLegend();
          }
        },
        height: 400,
        selection: {
          enabled: false
        },
        stacked: false,
        toolbar: {
          export: {
            csv: {
              headerCategory: 'Date'
            }
          },
          tools: {
            download: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/menu.svg">',
            zoom: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/zoom-range.svg">',
            zoomin: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/zoom-in.svg">',
            zoomout: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/zoom-out.svg">',
            pan: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/move.svg">',
            reset: '<img class="apex-chartmanage-icon" src="assets/icons/apexCharts/fit-to-screen.svg">'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: -10
      },
      series: this.seriesData,
      states: {
        hover: {
          filter: {
            type: 'none',
            value: 0
          }
        },
        active: {
          filter: {
            type: 'none',
            value: 0
          }
        }
      },
      stroke: {
        width: 1
      },
      tooltip: {
        y: {
          formatter: function (value: number, _options: ChartTooltipFormatterOptions) {
            return moneyToStr(value);
          }
        }
      },
      xaxis: {
        categories: this.xAxisCategories,
        type: 'datetime'
      },
      yaxis: {
        labels: {
          formatter: (value: number) => this.getYAxisLabel(value)
        }
      }
    };

    this.chart = new ApexCharts(this.ui.querySelector('.timeline-chart'), options);
    this.chart.render();
  }

  addFilterTextToLegend() {
    const element = document.querySelector('.timeline-chart > div > svg > foreignObject > div.apexcharts-legend');
    if (element && (element.firstElementChild as HTMLDivElement | null)?.innerText !== 'Filter: ') {
      const filterElement = document.createElement('div');
      filterElement.classList.add('filter-label');
      filterElement.classList.add('me-2');
      filterElement.innerText = 'Filter: ';
      element.prepend(filterElement);
    }
  }

  bodyTemplate(): EventTemplate {
    return html` <div class="timeline-chart"></div>
      <p>
        Information displayed on this widget are attributed to Current UTC, Time Zone (Coordinated Universal Time).<br />
        The values presented are the Dealer's Net Sell Price to the end customer.
      </p>`;
  }

  protected footerTemplate(): TemplateResult | null {
    return html` <button @click=${() => this.hideModal()} class="btn btn-secondary">${tlang`Close`}</button>`;
  }

  protected get modalSize() {
    return 'modal-xl';
  }

  protected getYAxisLabel(value: number): string {
    return `$${moneyToCompactStr(value)}`;
  }
}
